import React, { Fragment, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import HeaderEjercicios from '../../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../../Escritorio/Instrucciones';

import useConfigAuth from '../../../../Hooks/useConfigAuth';

import BotoneraBottom from '../../Compartidos/BotoneraBottom';

import {
    finalizarEjercicioAction,
    setearEjercicioAction,
    setearUrlAnteriorAction
} from '../../../../actions/estadoEjercicioActions';

import { almacenarAction } from '../../../../actions/almacenarEjercicioActions';

import {
    AvanzarImg,
    AvanzarBtn,
    PantallaM151,
    ContenidoM151,
    EscenaM151,
    BottomM151
} from '../../../Css/StyledMatematica';


// ============================================================================
// CONFIGURACIÓN
// ============================================================================

const CANTIDAD_EJERCICIOS = 5;

const MIN_PARTES = 2;
const MAX_PARTES = 6;

const ACCENT = '#23AAAF';
const MARK = '#E8662B';
const OK = '#2E8B57';
const INK = '#222';

const miniInstrucciones =
    'Observá la situación y armá la fracción exacta que representa lo que ves.';


// ============================================================================
// SITUACIONES BASE
// ============================================================================

const SITUACIONES = [

    {
        clave: 'viaje_buenos_aires',
        nombre: 'Viaje Buenos Aires',
        tipo: 'viaje',
        desde: 'Buenos Aires',
        icono: 'ciudad',
        texto:
            'Viajamos de Buenos Aires a la Costa. El auto muestra dónde estamos ahora.',
        pregunta:
            '¿Qué parte del viaje ya recorrimos?',
        pistaDen:
            'Contá en cuántas partes iguales está dividido el camino.',
        pistaNum:
            'Ahora contá cuántas partes ya recorrió el auto.'
    },

    {
        clave: 'viaje_casa',
        nombre: 'Viaje desde casa',
        tipo: 'viaje',
        desde: 'Casa',
        icono: 'casa',
        texto:
            'Salimos de casa para ir a la Costa. El auto muestra dónde estamos ahora.',
        pregunta:
            '¿Qué parte del viaje ya recorrimos?',
        pistaDen:
            'Contá en cuántas partes iguales está dividido el camino.',
        pistaNum:
            'Ahora contá cuántas partes ya recorrió el auto.'
    },

    {
        clave: 'botella_gaseosa',
        nombre: 'Botella gaseosa',
        tipo: 'botella',
        bebida: 'gaseosa',
        color: '#F28C28',
        tapa: '#C62828',
        texto:
            'Esta botella de gaseosa estaba llena. Ya tomamos un poco.',
        pregunta:
            '¿Cuánto queda en la botella?',
        pistaDen:
            'Contá en cuántas partes iguales está marcada la botella.',
        pistaNum:
            'Ahora contá cuántas partes tienen gaseosa.'
    },

    {
        clave: 'botella_agua',
        nombre: 'Botella agua',
        tipo: 'botella',
        bebida: 'agua',
        color: '#7EC8E3',
        tapa: '#1E88E5',
        texto:
            'Esta botella de agua estaba llena. Ya tomamos un poco.',
        pregunta:
            '¿Cuánto queda en la botella?',
        pistaDen:
            'Contá en cuántas partes iguales está marcada la botella.',
        pistaNum:
            'Ahora contá cuántas partes tienen agua.'
    },

    {
        clave: 'botella_jugo',
        nombre: 'Botella jugo',
        tipo: 'botella',
        bebida: 'jugo',
        color: '#F59E0B',
        tapa: '#2E8B57',
        texto:
            'Esta botella de jugo estaba llena. Ya tomamos un poco.',
        pregunta:
            '¿Cuánto queda en la botella?',
        pistaDen:
            'Contá en cuántas partes iguales está marcada la botella.',
        pistaNum:
            'Ahora contá cuántas partes tienen jugo.'
    },

    {
        clave: 'botellas_gaseosa',
        nombre: 'Botellas gaseosa',
        tipo: 'botellas',
        bebida: 'gaseosa',
        color: '#F28C28',
        tapa: '#C62828',
        mixto: true,
        texto:
            'Para el cumple tenemos estas botellas de gaseosa. Todas son del mismo tamaño.',
        pregunta:
            '¿Cuántas botellas de gaseosa tenemos?',
        pistaDen:
            'Mirá en cuántas partes iguales está marcada cada botella.',
        pistaNum:
            'Contá cuántas botellas están completamente llenas y qué parte tiene la otra.'
    },

    {
        clave: 'pizza',
        nombre: 'Pizza',
        tipo: 'pizza',
        texto:
            'Pedimos una pizza cortada en porciones iguales. Ya nos comimos algunas.',
        pregunta:
            '¿Qué parte de la pizza queda?',
        pistaDen:
            'Contá en cuántas porciones estaba cortada la pizza entera.',
        pistaNum:
            'Ahora contá cuántas porciones quedan en el plato.'
    },

    {
        clave: 'helado',
        nombre: 'Helado',
        tipo: 'kilo',
        texto:
            'Compramos un kilo de helado dividido en partes iguales. Ya comimos algunas partes.',
        pregunta:
            '¿Qué parte del kilo queda?',
        pistaDen:
            'Contá en cuántas partes iguales está dividido el pote.',
        pistaNum:
            'Ahora contá cuántas partes todavía tienen helado.'
    },

    {
        clave: 'huevos',
        nombre: 'Docena huevos',
        tipo: 'huevos',
        texto:
            'Teníamos una docena de huevos. Usamos algunos para hacer una torta.',
        pregunta:
            '¿Qué parte de la docena nos queda?',
        pistaDen:
            'Contá cuántos lugares tiene la huevera: eso es la docena entera.',
        pistaNum:
            'Ahora contá cuántos huevos quedan.'
    },

    {
        clave: 'bateria',
        nombre: 'Batería',
        tipo: 'bateria',
        texto:
            'Esta es la batería de mi celular. Cuando está llena, tiene todas las rayitas.',
        pregunta:
            '¿Cuánta batería le queda?',
        pistaDen:
            'Contá cuántas rayitas tiene la batería cuando está llena.',
        pistaNum:
            'Ahora contá cuántas rayitas están verdes.'
    }

];


// ============================================================================
// FUNCIONES RANDOM
// ============================================================================

const numeroRandom = (min, max) => {

    return Math.floor(
        Math.random() * (max - min + 1)
    ) + min;
};


const mezclar = (array) => {

    const copia = [...array];

    for (
        let i = copia.length - 1;
        i > 0;
        i--
    ) {

        const j = Math.floor(
            Math.random() * (i + 1)
        );

        [
            copia[i],
            copia[j]
        ] = [
            copia[j],
            copia[i]
        ];
    }

    return copia;
};


// ============================================================================
// GENERAR UNA SITUACIÓN
// ============================================================================

const generarSituacion = (
    situacion,
    index
) => {

    const nueva = {
        ...situacion,
        id: `${index + 1}`
    };


    // ------------------------------------------------------------------------
    // VIAJE
    // ------------------------------------------------------------------------

    if (
        situacion.tipo === 'viaje'
    ) {

        const partes =
            numeroRandom(
                MIN_PARTES,
                MAX_PARTES
            );

        const recorrido =
            numeroRandom(
                1,
                partes - 1
            );

        return {
            ...nueva,
            partes,
            recorrido,
            num: recorrido,
            den: partes,
            respuestaGuardado:
                `${recorrido}/${partes}`
        };
    }


    // ------------------------------------------------------------------------
    // BOTELLA
    // ------------------------------------------------------------------------

    if (
        situacion.tipo === 'botella'
    ) {

        const partes =
            numeroRandom(
                MIN_PARTES,
                MAX_PARTES
            );

        const nivel =
            numeroRandom(
                1,
                partes - 1
            );

        return {
            ...nueva,
            partes,
            nivel,
            num: nivel,
            den: partes,
            respuestaGuardado:
                `${nivel}/${partes}`
        };
    }


    // ------------------------------------------------------------------------
    // DOS BOTELLAS
    // ------------------------------------------------------------------------

    if (
        situacion.tipo === 'botellas'
    ) {

        const partes =
            numeroRandom(
                MIN_PARTES,
                MAX_PARTES
            );

        const nivel =
            numeroRandom(
                1,
                partes - 1
            );

        return {
            ...nueva,
            partes,
            niveles: [
                partes,
                nivel
            ],
            entero: 1,
            num: nivel,
            den: partes,
            respuestaGuardado:
                `1 y ${nivel}/${partes}`
        };
    }


    // ------------------------------------------------------------------------
    // PIZZA
    // ------------------------------------------------------------------------

    if (
        situacion.tipo === 'pizza'
    ) {

        const partes =
            numeroRandom(
                MIN_PARTES,
                MAX_PARTES
            );

        const comidas =
            numeroRandom(
                1,
                partes - 1
            );

        const quedan =
            partes - comidas;

        return {
            ...nueva,
            partes,
            comidas,
            num: quedan,
            den: partes,
            respuestaGuardado:
                `${quedan}/${partes}`
        };
    }


    // ------------------------------------------------------------------------
    // HELADO
    // ------------------------------------------------------------------------

    if (
        situacion.tipo === 'kilo'
    ) {

        const partes =
            numeroRandom(
                MIN_PARTES,
                MAX_PARTES
            );

        const cantidadComida =
            numeroRandom(
                1,
                partes - 1
            );

        const comidas =
            Array
                .from({
                    length:
                        cantidadComida
                })
                .map(
                    (_, i) => i
                );

        const quedan =
            partes -
            cantidadComida;

        return {
            ...nueva,
            partes,
            comidas,
            num: quedan,
            den: partes,
            respuestaGuardado:
                `${quedan}/${partes}`
        };
    }


    // ------------------------------------------------------------------------
    // HUEVOS
    //
    // La docena siempre tiene 12.
    // Lo random es cuántos quedan.
    // ------------------------------------------------------------------------

    if (
        situacion.tipo === 'huevos'
    ) {

        const partes = 12;

        const usados =
            numeroRandom(
                1,
                11
            );

        const quedan =
            partes -
            usados;

        return {
            ...nueva,
            partes,
            usados,
            num: quedan,
            den: partes,
            respuestaGuardado:
                `${quedan}/${partes}`
        };
    }


    // ------------------------------------------------------------------------
    // BATERÍA
    // ------------------------------------------------------------------------

    const partes =
        numeroRandom(
            MIN_PARTES,
            MAX_PARTES
        );

    const nivel =
        numeroRandom(
            1,
            partes - 1
        );

    return {
        ...nueva,
        partes,
        nivel,
        num: nivel,
        den: partes,
        respuestaGuardado:
            `${nivel}/${partes}`
    };
};


// ============================================================================
// DIBUJOS
// ============================================================================

const Auto = ({
    x,
    y
}) => {

    return (

        <g
            transform={
                `translate(${x - 30} ${y - 30})`
            }
        >

            <path
                d="M8 24 L16 10 Q18 6 23 6 L40 6 Q45 6 48 10 L54 18 L58 19 Q62 20 62 25 L62 32 L4 32 L4 27 Q4 24 8 24 Z"
                fill={MARK}
            />

            <path
                d="M19 12 Q20 10 23 10 L30 10 L30 19 L15 19 Z"
                fill="#DDF1F7"
            />

            <path
                d="M34 10 L40 10 Q43 10 45 12 L50 19 L34 19 Z"
                fill="#DDF1F7"
            />

            <circle
                cx={17}
                cy={32}
                r={7}
                fill={INK}
            />

            <circle
                cx={17}
                cy={32}
                r={3}
                fill="#bbb"
            />

            <circle
                cx={49}
                cy={32}
                r={7}
                fill={INK}
            />

            <circle
                cx={49}
                cy={32}
                r={3}
                fill="#bbb"
            />

        </g>
    );
};


const Ciudad = ({
    x,
    y
}) => {

    return (

        <g
            transform={
                `translate(${x} ${y})`
            }
        >

            <rect
                x={-46}
                y={-60}
                width={26}
                height={60}
                fill="#90A4AE"
            />

            <rect
                x={-18}
                y={-88}
                width={30}
                height={88}
                fill="#607D8B"
            />

            <rect
                x={14}
                y={-48}
                width={28}
                height={48}
                fill="#90A4AE"
            />

            {
                [-80, -66, -52, -38, -24]
                    .map(
                        wy => (

                            <g key={wy}>

                                <rect
                                    x={-12}
                                    y={wy}
                                    width={7}
                                    height={7}
                                    fill="#FFF3C4"
                                />

                                <rect
                                    x={1}
                                    y={wy}
                                    width={7}
                                    height={7}
                                    fill="#FFF3C4"
                                />

                            </g>
                        )
                    )
            }

            {
                [-50, -36, -22]
                    .map(
                        wy => (

                            <rect
                                key={wy}
                                x={-40}
                                y={wy}
                                width={14}
                                height={7}
                                fill="#FFF3C4"
                            />
                        )
                    )
            }

            {
                [-38, -24]
                    .map(
                        wy => (

                            <rect
                                key={wy}
                                x={20}
                                y={wy}
                                width={16}
                                height={7}
                                fill="#FFF3C4"
                            />
                        )
                    )
            }

        </g>
    );
};


const Casa = ({
    x,
    y
}) => {

    return (

        <g
            transform={
                `translate(${x} ${y})`
            }
        >

            <polygon
                points="-40,-46 0,-80 40,-46"
                fill="#C0392B"
            />

            <rect
                x={-32}
                y={-46}
                width={64}
                height={46}
                fill="#F4D9A8"
            />

            <rect
                x={-9}
                y={-28}
                width={18}
                height={28}
                fill="#8D5524"
            />

            <rect
                x={-27}
                y={-38}
                width={13}
                height={13}
                fill="#DDF1F7"
                stroke="#8D5524"
                strokeWidth={1.5}
            />

            <rect
                x={14}
                y={-38}
                width={13}
                height={13}
                fill="#DDF1F7"
                stroke="#8D5524"
                strokeWidth={1.5}
            />

        </g>
    );
};


const Playa = ({
    x,
    y
}) => {

    return (

        <g
            transform={
                `translate(${x} ${y})`
            }
        >

            <circle
                cx={30}
                cy={-82}
                r={16}
                fill="#FFC93C"
            />

            <path
                d="M-50 0 Q-30 -22 0 -18 Q30 -14 50 0 Z"
                fill="#F3D9A4"
            />

            <path
                d="M-50 -24 q10 -8 20 0 t20 0 t20 0 t20 0 t20 0"
                fill="none"
                stroke="#4FA3D1"
                strokeWidth={4}
                strokeLinecap="round"
            />

            <path
                d="M-44 -38 q10 -8 20 0 t20 0 t20 0 t20 0"
                fill="none"
                stroke="#7EC8E3"
                strokeWidth={4}
                strokeLinecap="round"
            />

            <line
                x1={-6}
                y1={-6}
                x2={-6}
                y2={-70}
                stroke="#8D5524"
                strokeWidth={3}
            />

            <path
                d="M-40 -64 Q-6 -100 28 -64 Z"
                fill={MARK}
            />

        </g>
    );
};


const Viaje = ({
    s
}) => {

    const x1 = 150;
    const x2 = 620;

    const roadY = 150;

    const largo =
        x2 - x1;

    const carX =
        x1 +
        (
            s.recorrido /
            s.partes
        ) *
        largo;


    return (

        <svg
            viewBox="0 0 760 230"
            role="img"
            aria-label="Camino del viaje"
        >

            <rect
                width={760}
                height={230}
                fill="#FFFFFF"
            />

            {
                s.icono === 'ciudad'

                    ?

                    <Ciudad
                        x={80}
                        y={roadY + 18}
                    />

                    :

                    <Casa
                        x={80}
                        y={roadY + 18}
                    />
            }

            <Playa
                x={685}
                y={roadY + 18}
            />

            <text
                x={80}
                y={roadY + 48}
                textAnchor="middle"
                fontSize="18"
                fontWeight="700"
                fill={INK}
            >
                {s.desde}
            </text>

            <text
                x={685}
                y={roadY + 48}
                textAnchor="middle"
                fontSize="18"
                fontWeight="700"
                fill={INK}
            >
                La Costa
            </text>

            <rect
                x={x1}
                y={roadY - 16}
                width={largo}
                height={32}
                rx={4}
                fill="#555"
            />

            <line
                x1={x1 + 6}
                y1={roadY}
                x2={x2 - 6}
                y2={roadY}
                stroke="#FFFFFF"
                strokeWidth={3}
                strokeDasharray="14 12"
            />

            {
                Array
                    .from({
                        length:
                            s.partes + 1
                    })
                    .map(
                        (_, i) => {

                            const px =
                                x1 +
                                (
                                    i /
                                    s.partes
                                ) *
                                largo;

                            return (

                                <g key={i}>

                                    <rect
                                        x={px - 4}
                                        y={roadY + 18}
                                        width={8}
                                        height={22}
                                        rx={2}
                                        fill="#FFFFFF"
                                        stroke={INK}
                                        strokeWidth={2}
                                    />

                                    <rect
                                        x={px - 4}
                                        y={roadY + 18}
                                        width={8}
                                        height={7}
                                        fill={MARK}
                                    />

                                </g>
                            );
                        }
                    )
            }

            <Auto
                x={carX}
                y={roadY - 4}
            />

        </svg>
    );
};


const Botella = ({
    color,
    tapa,
    partes,
    nivel,
    id,
    label
}) => {

    const top = 105;
    const bottom = 290;

    const alto =
        bottom - top;

    const nivelY =
        bottom -
        (
            nivel /
            partes
        ) *
        alto;

    const contorno =
        'M62 22 h36 v33 q32 10 32 50 v165 q0 20 -20 20 h-60 q-20 0 -20 -20 v-165 q0 -40 32 -50 z';

    const clipId =
        `clip-botella-${id}`;


    return (

        <svg
            viewBox="0 0 160 300"
            role="img"
            aria-label={label}
        >

            <defs>

                <clipPath
                    id={clipId}
                >

                    <path
                        d={contorno}
                    />

                </clipPath>

            </defs>

            <path
                d={contorno}
                fill="#F7FBFC"
            />

            <rect
                x={0}
                y={nivelY}
                width={160}
                height={
                    300 - nivelY
                }
                fill={color}
                clipPath={
                    `url(#${clipId})`
                }
            />

            {
                Array
                    .from({
                        length:
                            partes
                    })
                    .map(
                        (_, i) => {

                            const y =
                                bottom -
                                (
                                    (
                                        i + 1
                                    ) /
                                    partes
                                ) *
                                alto;

                            return (

                                <line
                                    key={i}
                                    x1={30}
                                    y1={y}
                                    x2={130}
                                    y2={y}
                                    stroke={INK}
                                    strokeWidth={2}
                                    strokeDasharray="6 5"
                                    opacity={0.7}
                                />
                            );
                        }
                    )
            }

            <path
                d={contorno}
                fill="none"
                stroke={INK}
                strokeWidth={3}
            />

            <rect
                x={58}
                y={6}
                width={44}
                height={20}
                rx={4}
                fill={tapa}
                stroke={INK}
                strokeWidth={2}
            />

        </svg>
    );
};


// ============================================================================
// SECTOR DE CÍRCULO
// ============================================================================

const sector = (
    cx,
    cy,
    r,
    a0,
    a1
) => {

    const punto = (
        angulo
    ) => [

        cx +
        r *
        Math.sin(
            (
                angulo *
                Math.PI
            ) /
            180
        ),

        cy -
        r *
        Math.cos(
            (
                angulo *
                Math.PI
            ) /
            180
        )
    ];


    const [x0, y0] =
        punto(a0);

    const [x1, y1] =
        punto(a1);

    const large =
        a1 - a0 > 180
            ? 1
            : 0;


    return (
        `M${cx} ${cy} L${x0} ${y0} A${r} ${r} 0 ${large} 1 ${x1} ${y1} Z`
    );
};


// ============================================================================
// PIZZA
// ============================================================================

const Pizza = ({
    s
}) => {

    const cx = 150;
    const cy = 150;

    const paso =
        360 /
        s.partes;


    return (

        <svg
            viewBox="0 0 300 300"
            role="img"
            aria-label="Pizza en porciones"
        >

            <circle
                cx={cx}
                cy={cy}
                r={142}
                fill="#FFFFFF"
                stroke="#CFCFCF"
                strokeWidth={3}
            />

            {
                Array
                    .from({
                        length:
                            s.partes
                    })
                    .map(
                        (_, i) => {

                            const a0 =
                                i *
                                paso;

                            const a1 =
                                (
                                    i + 1
                                ) *
                                paso;


                            if (
                                i <
                                s.comidas
                            ) {

                                return (

                                    <path
                                        key={i}
                                        d={
                                            sector(
                                                cx,
                                                cy,
                                                126,
                                                a0 + 0.8,
                                                a1 - 0.8
                                            )
                                        }
                                        fill="none"
                                        stroke="#9E9E9E"
                                        strokeWidth={2.5}
                                        strokeDasharray="7 6"
                                        strokeLinejoin="round"
                                    />
                                );
                            }


                            const am =
                                (
                                    (
                                        a0 +
                                        a1
                                    ) /
                                    2
                                ) *
                                (
                                    Math.PI /
                                    180
                                );


                            return (

                                <g key={i}>

                                    <path
                                        d={
                                            sector(
                                                cx,
                                                cy,
                                                128,
                                                a0,
                                                a1
                                            )
                                        }
                                        fill="#D99A4E"
                                        stroke="#FFFFFF"
                                        strokeWidth={4}
                                        strokeLinejoin="round"
                                    />

                                    <path
                                        d={
                                            sector(
                                                cx,
                                                cy,
                                                112,
                                                a0 + 1.5,
                                                a1 - 1.5
                                            )
                                        }
                                        fill="#F7D774"
                                    />

                                    <circle
                                        cx={
                                            cx +
                                            72 *
                                            Math.sin(
                                                am
                                            )
                                        }
                                        cy={
                                            cy -
                                            72 *
                                            Math.cos(
                                                am
                                            )
                                        }
                                        r={7}
                                        fill="#2E3B1F"
                                    />

                                    <circle
                                        cx={
                                            cx +
                                            40 *
                                            Math.sin(
                                                am +
                                                0.15
                                            )
                                        }
                                        cy={
                                            cy -
                                            40 *
                                            Math.cos(
                                                am +
                                                0.15
                                            )
                                        }
                                        r={6}
                                        fill="#D9442B"
                                        opacity={0.85}
                                    />

                                </g>
                            );
                        }
                    )
            }

        </svg>
    );
};


// ============================================================================
// HELADO
// ============================================================================

const Kilo = ({
    s
}) => {

    const sabores = [
        '#C68B4E',
        '#6B3E26',
        '#F4A3B4',
        '#F2EBB5',
        '#B6D7A8',
        '#D7BDE2'
    ];

    const r = 110;
    const ry = 44;

    const k =
        ry / r;

    const cx = 160;
    const topY = 70;

    const paso =
        360 /
        s.partes;


    return (

        <svg
            viewBox="0 0 320 260"
            role="img"
            aria-label="Pote de un kilo de helado"
        >

            <path
                d={
                    `M${cx - 128} ${topY}
                    L${cx - 98} ${topY + 160}
                    Q${cx} ${topY + 186} ${cx + 98} ${topY + 160}
                    L${cx + 128} ${topY} Z`
                }
                fill="#FFFFFF"
                stroke="#BDBDBD"
                strokeWidth={3}
                strokeLinejoin="round"
            />

            <text
                x={cx}
                y={topY + 120}
                textAnchor="middle"
                fontSize="22"
                fontWeight="800"
                fill="#9E9E9E"
                letterSpacing="2"
            >
                1 KG
            </text>

            <ellipse
                cx={cx}
                cy={topY}
                rx={128}
                ry={50}
                fill="#FFFFFF"
                stroke="#BDBDBD"
                strokeWidth={3}
            />

            <ellipse
                cx={cx}
                cy={topY}
                rx={r + 2}
                ry={ry + 1}
                fill="#E9E9E9"
            />

            <g
                transform={
                    `translate(${cx} ${topY}) scale(1 ${k})`
                }
            >

                {
                    Array
                        .from({
                            length:
                                s.partes
                        })
                        .map(
                            (_, i) => {

                                const a0 =
                                    i *
                                    paso +
                                    45;

                                const a1 =
                                    (
                                        i + 1
                                    ) *
                                    paso +
                                    45;

                                const vacio =
                                    s.comidas
                                        .includes(
                                            i
                                        );


                                return (

                                    <path
                                        key={i}
                                        d={
                                            sector(
                                                0,
                                                0,
                                                r,
                                                a0,
                                                a1
                                            )
                                        }
                                        fill={
                                            vacio

                                                ? '#ECECEC'

                                                : sabores[
                                                    i %
                                                    sabores.length
                                                ]
                                        }
                                        stroke="#FFFFFF"
                                        strokeWidth={3}
                                    />
                                );
                            }
                        )
                }

            </g>

            <ellipse
                cx={cx}
                cy={topY}
                rx={r + 2}
                ry={ry + 1}
                fill="none"
                stroke="#D0D0D0"
                strokeWidth={2}
            />

        </svg>
    );
};


// ============================================================================
// HUEVOS
// ============================================================================

const Huevos = ({
    s
}) => {

    const cols = 6;

    const quedan =
        s.partes -
        s.usados;


    return (

        <svg
            viewBox="0 0 400 190"
            role="img"
            aria-label="Huevera de una docena"
        >

            <rect
                x={10}
                y={20}
                width={380}
                height={160}
                rx={18}
                fill="#CDBB9E"
                stroke="#9C8A6E"
                strokeWidth={3}
            />

            {
                Array
                    .from({
                        length:
                            s.partes
                    })
                    .map(
                        (_, i) => {

                            const columna =
                                i %
                                cols;

                            const fila =
                                Math.floor(
                                    i /
                                    cols
                                );

                            const x =
                                45 +
                                columna *
                                62;

                            const y =
                                65 +
                                fila *
                                72;

                            const hay =
                                i <
                                quedan;


                            return (

                                <g key={i}>

                                    <circle
                                        cx={x}
                                        cy={y}
                                        r={26}
                                        fill="#B6A385"
                                        stroke="#9C8A6E"
                                        strokeWidth={2}
                                    />

                                    {
                                        hay && (

                                            <>

                                                <ellipse
                                                    cx={x}
                                                    cy={y - 4}
                                                    rx={22}
                                                    ry={27}
                                                    fill="#FFF4E0"
                                                    stroke="#C9B48F"
                                                    strokeWidth={2}
                                                />

                                                <ellipse
                                                    cx={x - 7}
                                                    cy={y - 14}
                                                    rx={5}
                                                    ry={8}
                                                    fill="#FFFFFF"
                                                    opacity={0.8}
                                                />

                                            </>
                                        )
                                    }

                                </g>
                            );
                        }
                    )
            }

        </svg>
    );
};


// ============================================================================
// BATERÍA
// ============================================================================

const Bateria = ({
    s
}) => {

    const w = 300;
    const h = 130;

    const pad = 12;
    const gap = 8;

    const segW =
        (
            w -
            pad * 2 -
            gap *
            (
                s.partes -
                1
            )
        ) /
        s.partes;


    return (

        <svg
            viewBox="0 0 340 150"
            role="img"
            aria-label="Batería del celular"
        >

            <rect
                x={6}
                y={10}
                width={w}
                height={h}
                rx={18}
                fill="#FFFFFF"
                stroke={INK}
                strokeWidth={5}
            />

            <rect
                x={w + 6}
                y={
                    10 +
                    h / 2 -
                    22
                }
                width={20}
                height={44}
                rx={6}
                fill={INK}
            />

            {
                Array
                    .from({
                        length:
                            s.partes
                    })
                    .map(
                        (_, i) => (

                            <rect
                                key={i}
                                x={
                                    6 +
                                    pad +
                                    i *
                                    (
                                        segW +
                                        gap
                                    )
                                }
                                y={
                                    10 +
                                    pad
                                }
                                width={segW}
                                height={
                                    h -
                                    pad * 2
                                }
                                rx={6}
                                fill={
                                    i <
                                    s.nivel

                                        ? '#43A047'
                                        : '#FFFFFF'
                                }
                                stroke={
                                    i <
                                    s.nivel

                                        ? '#2E7D32'
                                        : '#BDBDBD'
                                }
                                strokeWidth={2.5}
                            />
                        )
                    )
            }

        </svg>
    );
};


// ============================================================================
// ESCENA
// ============================================================================

const Escena = ({
    s
}) => {

    if (
        s.tipo === 'viaje'
    ) {

        return (
            <Viaje
                s={s}
            />
        );
    }


    if (
        s.tipo === 'botella'
    ) {

        return (

            <Botella
                id={`${s.bebida}-${s.id}`}
                label={
                    `Botella de ${s.bebida}`
                }
                color={s.color}
                tapa={s.tapa}
                partes={s.partes}
                nivel={s.nivel}
            />
        );
    }


    if (
        s.tipo === 'botellas'
    ) {

        return (

            <div
                className="m151-botellas"
            >

                {
                    s.niveles
                        .map(
                            (
                                nivel,
                                index
                            ) => (

                                <Botella
                                    key={index}
                                    id={
                                        `${s.bebida}-${s.id}-${index}`
                                    }
                                    label={
                                        `Botella ${index + 1}`
                                    }
                                    color={s.color}
                                    tapa={s.tapa}
                                    partes={s.partes}
                                    nivel={nivel}
                                />
                            )
                        )
                }

            </div>
        );
    }


    if (
        s.tipo === 'pizza'
    ) {

        return (
            <Pizza
                s={s}
            />
        );
    }


    if (
        s.tipo === 'kilo'
    ) {

        return (
            <Kilo
                s={s}
            />
        );
    }


    if (
        s.tipo === 'huevos'
    ) {

        return (
            <Huevos
                s={s}
            />
        );
    }


    return (
        <Bateria
            s={s}
        />
    );
};


// ============================================================================
// CONTADOR
// ============================================================================

const botonContador = {

    fontFamily: 'Nunito',
    fontSize: 22,
    fontWeight: 700,

    width: 42,
    height: 36,

    borderRadius: 10,

    border:
        `2px solid ${ACCENT}`,

    background:
        '#FFFFFF',

    color:
        ACCENT,

    cursor:
        'pointer'
};


const Contador = ({
    valor,
    onCambio,
    min,
    max = 12,
    disabled,
    etiqueta,
    vertical = false
}) => {


    const restar = () => {

        if (disabled) {
            return;
        }

        if (
            valor === null
        ) {

            onCambio(
                min
            );

            return;
        }

        onCambio(
            Math.max(
                min,
                valor - 1
            )
        );
    };


    const sumar = () => {

        if (disabled) {
            return;
        }

        if (
            valor === null
        ) {

            onCambio(
                Math.max(
                    min,
                    1
                )
            );

            return;
        }

        onCambio(
            Math.min(
                max,
                valor + 1
            )
        );
    };


    const caja = (

        <div
            style={{
                width: 56,
                height: 56,
                border:
                    `3px solid ${INK}`,
                borderRadius: 10,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontFamily: 'Nunito',
                fontSize: 30,
                fontWeight: 700,
                color:
                    valor === null

                        ? '#AAAAAA'
                        : INK
            }}
        >
            {
                valor === null
                    ? '?'
                    : valor
            }
        </div>
    );


    const menos = (

        <button
            type="button"
            style={{
                ...botonContador,
                opacity:
                    disabled
                        ? 0.4
                        : 1
            }}
            disabled={disabled}
            aria-label={
                `Restar ${etiqueta}`
            }
            onClick={restar}
        >
            −
        </button>
    );


    const mas = (

        <button
            type="button"
            style={{
                ...botonContador,
                opacity:
                    disabled
                        ? 0.4
                        : 1
            }}
            disabled={disabled}
            aria-label={
                `Sumar ${etiqueta}`
            }
            onClick={sumar}
        >
            +
        </button>
    );


    if (
        vertical
    ) {

        return (

            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 6
                }}
            >

                {mas}

                {caja}

                {menos}

            </div>
        );
    }


    return (

        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10
            }}
        >

            {menos}

            {caja}

            {mas}

        </div>
    );
};


// ============================================================================
// M151
// ============================================================================

const M151 = () => {


    const dispatch =
        useDispatch();


    const navigate =
        useNavigate();


    const [config] =
        useConfigAuth();


    // ------------------------------------------------------------------------
    // REDUX
    // ------------------------------------------------------------------------

    const iniciar =
        useSelector(
            state =>
                state.ejercicio.iniciar
        );


    const finalizar =
        useSelector(
            state =>
                state.ejercicio.finalizar
        );


    const id_paciente =
        useSelector(
            state =>
                state.usuario.id_paciente
        );


    const sesion =
        useSelector(
            state =>
                state.ejercicio.sesion
        );


    // ------------------------------------------------------------------------
    // EJERCICIOS
    // ------------------------------------------------------------------------

    const [
        ejercicios,
        setEjercicios
    ] = useState([]);


    const [
        count,
        setCount
    ] = useState(1);


    // ------------------------------------------------------------------------
    // RESPUESTA
    // ------------------------------------------------------------------------

    const [
        ent,
        setEnt
    ] = useState(null);


    const [
        num,
        setNum
    ] = useState(null);


    const [
        den,
        setDen
    ] = useState(null);


    // ------------------------------------------------------------------------
    // ESTADO
    // ------------------------------------------------------------------------

    const [
        feedback,
        setFeedback
    ] = useState(null);


    const [
        disable,
        setDisable
    ] = useState(false);


    const [
        resuelto,
        setResuelto
    ] = useState(false);


    // ------------------------------------------------------------------------
    // ERRORES
    // ------------------------------------------------------------------------

    const [
        contarErrores,
        setContarErrores
    ] = useState(0);


    const [
        erroresItemActual,
        setErroresItemActual
    ] = useState(0);


    const [
        erroresOrden,
        setErroresOrden
    ] = useState([]);


    // ------------------------------------------------------------------------
    // EJERCICIO ACTUAL
    // ------------------------------------------------------------------------

    const ejercicioActual =
        ejercicios.length > 0

            ? ejercicios[
                count - 1
            ]

            : null;


    // ------------------------------------------------------------------------
    // SONIDOS
    // ------------------------------------------------------------------------

    const GoodWork = () => {

        new Audio(
            '/sounds/sonido_bien.mp3'
        ).play();
    };


    const TryAgain = () => {

        new Audio(
            '/sounds/sonidoMal.mp3'
        ).play();
    };


    // ------------------------------------------------------------------------
    // CAMBIAR RESPUESTA
    // ------------------------------------------------------------------------

    const cambiar = (
        setter
    ) => {

        return (
            valor
        ) => {

            setter(
                valor
            );

            setFeedback(
                null
            );
        };
    };


    // ------------------------------------------------------------------------
    // ERROR
    // ------------------------------------------------------------------------

    const marcarError = (
        texto
    ) => {

        setContarErrores(
            errores =>
                errores + 1
        );


        setErroresItemActual(
            errores =>
                errores + 1
        );


        setFeedback({
            ok: false,
            text: texto
        });


        setDisable(
            true
        );


        TryAgain();


        setTimeout(() => {

            setDisable(
                false
            );

        }, 500);
    };


    // ------------------------------------------------------------------------
    // LIMPIAR ÍTEM
    // ------------------------------------------------------------------------

    const limpiarEjercicio = () => {

        setEnt(
            null
        );

        setNum(
            null
        );

        setDen(
            null
        );

        setFeedback(
            null
        );

        setDisable(
            false
        );

        setResuelto(
            false
        );

        setErroresItemActual(
            0
        );
    };


    // ------------------------------------------------------------------------
    // VERIFICAR
    // ------------------------------------------------------------------------

    const verificar = (
        e
    ) => {

        e.preventDefault();


        if (
            disable ||
            resuelto ||
            !ejercicioActual
        ) {

            return;
        }


        // --------------------------------------------------------------------
        // RESPUESTA INCOMPLETA
        // --------------------------------------------------------------------

        if (
            num === null ||
            den === null ||
            (
                ejercicioActual.mixto &&
                ent === null
            )
        ) {

            marcarError(
                'Completá todos los números de la respuesta.'
            );

            return;
        }


        // --------------------------------------------------------------------
        // DENOMINADOR EXACTO
        //
        // NO SE ACEPTAN EQUIVALENTES.
        //
        // Si la imagen muestra 2/4,
        // tiene que responder 2/4.
        // --------------------------------------------------------------------

        if (
            den !==
            ejercicioActual.den
        ) {

            marcarError(
                ejercicioActual.pistaDen
            );

            return;
        }


        // --------------------------------------------------------------------
        // ENTERO EN SITUACIÓN MIXTA
        // --------------------------------------------------------------------

        if (
            ejercicioActual.mixto &&
            ent !==
            ejercicioActual.entero
        ) {

            marcarError(
                'Contá cuántas botellas están completamente llenas.'
            );

            return;
        }


        // --------------------------------------------------------------------
        // NUMERADOR EXACTO
        // --------------------------------------------------------------------

        if (
            num !==
            ejercicioActual.num
        ) {

            marcarError(
                ejercicioActual.pistaNum
            );

            return;
        }


        // --------------------------------------------------------------------
        // CORRECTO
        // --------------------------------------------------------------------

        setDisable(
            true
        );

        setResuelto(
            true
        );


        setFeedback({
            ok: true,
            text: '¡Muy bien!'
        });


        GoodWork();


        const nuevoErroresOrden = [
            ...erroresOrden,
            erroresItemActual
        ];


        setErroresOrden(
            nuevoErroresOrden
        );


        // --------------------------------------------------------------------
        // SIGUIENTE
        // --------------------------------------------------------------------

        if (
            count <
            ejercicios.length
        ) {

            setTimeout(() => {

                limpiarEjercicio();


                setCount(
                    contador =>
                        contador + 1
                );

            }, 1000);

        } else {

            setTimeout(() => {

                dispatch(
                    finalizarEjercicioAction()
                );

            }, 1500);
        }
    };


    // =========================================================================
    // GENERAR LOS 5 EJERCICIOS
    // =========================================================================

    useEffect(() => {

        const situacionesRandom =
            mezclar(
                SITUACIONES
            )
                .slice(
                    0,
                    CANTIDAD_EJERCICIOS
                )
                .map(
                    (
                        situacion,
                        index
                    ) =>

                        generarSituacion(
                            situacion,
                            index
                        )
                );


        setEjercicios(
            situacionesRandom
        );


        dispatch(
            setearEjercicioAction(
                'M151'
            )
        );


        dispatch(
            setearUrlAnteriorAction(
                'matematica/fracciones/'
            )
        );


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    // =========================================================================
    // FINALIZAR Y GUARDAR
    // =========================================================================

    useEffect(() => {

        if (
            !finalizar
        ) {

            return;
        }


        const listaUsada =
            ejercicios.map(
                item =>
                    item.respuestaGuardado
            );


        const informacion = {

            config,

            payload: {

                ejercicio:
                    'M151',

                errores:
                    contarErrores,

                lista_usada:
                    listaUsada,

                erroresOrden,

                id_paciente,

                sesion
            }
        };


        dispatch(
            almacenarAction(
                informacion
            )
        );


        navigate(
            '/escritorio/metodos/finalizar-ejercicio'
        );


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar]);


    // =========================================================================
    // PANTALLA DE INSTRUCCIONES
    // =========================================================================

    if (
        !iniciar
    ) {

        return (

            <Fragment>

                <HeaderEjercicios
                    estrellas={true}
                    carrito={true}
                    minMay={false}
                />

                <Instrucciones
                    miniInstrucciones={
                        miniInstrucciones
                    }
                />

            </Fragment>
        );
    }


    if (
        !ejercicioActual
    ) {

        return null;
    }


    // =========================================================================
    // RENDER
    // =========================================================================

    return (

        <PantallaM151>


            {/* ============================================================= */}
            {/* HEADER                                                        */}
            {/* ============================================================= */}

            <HeaderEjercicios
                estrellas={true}
                carrito={true}
                minMay={false}
            />


            {/* ============================================================= */}
            {/* CONTENIDO                                                     */}
            {/* ============================================================= */}

            <ContenidoM151>

                <p
                    style={{
                        fontFamily: 'Nunito',
                        fontSize: 22,
                        fontWeight: 500,
                        textAlign: 'center',
                        margin: 0,
                        lineHeight: 1.3
                    }}
                >
                    {ejercicioActual.texto}
                </p>


                <EscenaM151>

                    <Escena
                        s={
                            ejercicioActual
                        }
                    />

                </EscenaM151>


                <p
                    style={{
                        fontFamily: 'Nunito',
                        fontSize: 24,
                        fontWeight: 700,
                        textAlign: 'center',
                        margin: 0,
                        lineHeight: 1.2
                    }}
                >
                    {
                        ejercicioActual
                            .pregunta
                    }
                </p>


                {/* ========================================================= */}
                {/* RESPUESTA                                                 */}
                {/* ========================================================= */}

                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 24,
                        flexShrink: 0
                    }}
                >

                    {
                        ejercicioActual.mixto && (

                            <>

                                <Contador
                                    valor={ent}
                                    onCambio={
                                        cambiar(
                                            setEnt
                                        )
                                    }
                                    min={0}
                                    max={2}
                                    disabled={
                                        disable ||
                                        resuelto
                                    }
                                    etiqueta="enteros"
                                    vertical={true}
                                />

                                <span
                                    style={{
                                        fontFamily: 'Nunito',
                                        fontSize: 24,
                                        fontWeight: 700
                                    }}
                                >
                                    y
                                </span>

                            </>
                        )
                    }


                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 7
                        }}
                    >

                        <Contador
                            valor={num}
                            onCambio={
                                cambiar(
                                    setNum
                                )
                            }
                            min={0}
                            max={12}
                            disabled={
                                disable ||
                                resuelto
                            }
                            etiqueta="numerador"
                        />


                        <div
                            style={{
                                width: 80,
                                height: 4,
                                background: INK,
                                borderRadius: 2
                            }}
                        />


                        <Contador
                            valor={den}
                            onCambio={
                                cambiar(
                                    setDen
                                )
                            }
                            min={1}
                            max={12}
                            disabled={
                                disable ||
                                resuelto
                            }
                            etiqueta="denominador"
                        />

                    </div>

                </div>


                {/* ========================================================= */}
                {/* FEEDBACK                                                  */}
                {/* ========================================================= */}

                <p
                    style={{
                        minHeight: 24,
                        margin: 0,
                        padding: '0 10px',
                        fontFamily: 'Nunito',
                        fontSize: 18,
                        fontWeight: 600,
                        textAlign: 'center',
                        color:

                            feedback

                                ? feedback.ok

                                    ? OK
                                    : MARK

                                : 'transparent'
                    }}
                    aria-live="polite"
                >
                    {
                        feedback
                            ? feedback.text
                            : '.'
                    }
                </p>


            </ContenidoM151>


            {/* ============================================================= */}
            {/* BOTTOM                                                        */}
            {/* ============================================================= */}

            <BottomM151>


                <BotoneraBottom
                    miniInstrucciones={
                        miniInstrucciones
                    }
                />


                <AvanzarBtn
                    disabled={
                        disable ||
                        resuelto
                    }
                    onClick={
                        verificar
                    }
                >

                    <AvanzarImg
                        src="/img/play.png"
                    />

                </AvanzarBtn>


            </BottomM151>


        </PantallaM151>
    );
};


export default M151;